import React from "react";
import { CgCloseO } from "react-icons/cg";
import "./styles.css";

const CommonModal = ({ isOpen, onClose, children, customStyles }) => {
  if (isOpen) {
    return (
      <div
        style={{
          width: "100vw",
          minHeight: "100vh",
          top: "0",
          left: "0",
          position: "fixed",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 99,
        }}
      >
        <div
          style={{
            width: "100vw",
            height: "100%",
            top: "0",
            left: "0",
            position: "absolute",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        ></div>
        <div className="common-modal-container" style={customStyles}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
            }}
          >
            <div
              style={{ padding: 10, marginRight: -10, cursor: "pointer" }}
              onClick={() => onClose()}
            >
              <CgCloseO size={30} />
            </div>
          </div>
          <div>{children}</div>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

export default CommonModal;
